import { ErrorResponse, handlerApiError } from '../../../../lib/basicRepository';
import { restApi } from '../../../../services/api';
import { inputCodeWithoutZeroWidthSpace } from '../../../../utils/regexes';
import {
  ProductActionsRequestParams,
  ProductActionsResponseData,
  ProductActionsSearchResponseData,
  SearchProductParams,
  ShopByIncrementParams,
  ShopByMode,
  ShopByResultOutput,
} from '../types/productActions.types';

const shopProduct = async ({
  productColorId,
  orderId,
  availability,
}: ProductActionsRequestParams) => {
  const response = await restApi.post<ProductActionsResponseData, ErrorResponse>(
    `/products/actions/shop`,
    {
      productColorId,
      orderId,
      availability,
    },
  );
  return handlerApiError<ProductActionsResponseData>(response);
};

const shopByProduct = async (orderId: string, code: string) => {
  const response = await restApi.post<ShopByResultOutput, ErrorResponse>(
    `/products/actions/shop-by`,
    {
      code,
      orderId,
    },
  );
  return handlerApiError<ShopByResultOutput>(response);
};

const shopByIncrement = async ({ orderId, code, filter }: ShopByIncrementParams) => {
  const response = await restApi.post<ShopByResultOutput, ErrorResponse>(
    `/products/actions/shop-by`,
    {
      orderId,
      filter,
      code: inputCodeWithoutZeroWidthSpace(code),
      mode: ShopByMode.INCREMENT,
    },
  );
  return handlerApiError<ShopByResultOutput>(response);
};

const unshopProduct = async ({ productColorId, orderId }: ProductActionsRequestParams) => {
  const response = await restApi.post<ProductActionsResponseData, ErrorResponse>(
    `/products/actions/unshop`,
    {
      productColorId,
      orderId,
    },
  );
  return handlerApiError<ProductActionsResponseData>(response);
};

const searchProduct = async ({
  codeOrBarcodeOrName,
  isAdminSeller,
  catalogId,
  orderId,
}: SearchProductParams) => {
  const response = await restApi.post<ProductActionsSearchResponseData, ErrorResponse>(
    `/products/actions/search`,
    {
      codeOrBarcodeOrName: inputCodeWithoutZeroWidthSpace(codeOrBarcodeOrName),
      isAdminSeller,
      catalogId,
      orderId,
    },
  );
  return handlerApiError<ProductActionsSearchResponseData>(response);
};

export const onlineProductActionRepository = {
  shopProduct,
  shopByProduct,
  shopByIncrement,
  unshopProduct,
  searchProduct,
};
